export interface IPricingItemSearchApi {
    total: number;
    limit: number;
    skip: number;
    data: IPriceItem[]
}
export interface IGroupPricingSearchApi {
    total: number;
    limit: number;
    skip: number;
    data: IGroupPriceItem[]
}

export interface IGroupPriceItem {
    itemcode: string;
    price: string;
}

export enum StatusOfNewPricingRequest {
    None,
    Saving,
    ErrorNotAllItemsHaveQuantityAndPrice,
    ErrorTryAgain,
    Success,
}

export interface IPricingNewRequest {
    showModal: boolean;
    status: StatusOfNewPricingRequest;
    id: number;
    providerId: number;
    items: INewPriceItem[];
    isNew: boolean;
    descriptionHtml: string;
    descriptionText: string;
}

export interface IPricingRequestFindApi {
    total: number;
    limit: number;
    skip: number;
    data: IPricingFullApi[];
}

export interface IPricingFullApi {
    complete: 1 | 0
    createdAt: string
    createdByUserId: number
    id: number
    item: IPriceItem[];
    note: string
    providerId: number
    updatedAt: string
}

export interface IPriceItem {
    id: number;
    itemcode: string;
    itemname?: string | null;

    isNew: boolean;
    ndc: string;
    form: string;
    onhand: number;
    price: number;
    minorder: 1 | 0;

    volume: number;

    customerPrice: string | null;
    expectedPrice: number;
    approvedPrice: number | null;

    createdByUserId: number | null;
    approvedByUserId: number | null;

    complete: 1 | 0;
    approved: 1 | 0;
    createdAt: string;
    updatedAt: string;
    note: string;
    providerId: number;

    pricingRequestId: number;
}

export interface INewPriceItem {
    id: number;
    isNew: boolean;
    itemcode: string;
    itemname?: string | null;
    price: number;
    expectedPrice: string;
    approvedPrice: string | null;
    volume: string;
}

export interface IGetPricingRequestApi {
    total: number;
    limit: number;
    skip: number;
    data: IPricingRequest[];
}

export interface IPricingRequest {
    id: number;
    createdByUser: {
        id: number;
        name: string;
        username: string;
        email: string | null;
    };
    createdByUserId: number;
    note: string | null;
    complete: 1 | 0;
    createdAt: string;
    updatedAt: string;
    providerId: number;
    provider: {
        databaseId: number;
        providerId: number;
        legalBusName: string | null;
        dba: string | null;
        groupId: number | null;
        providerGroup: {
            id: number;
            name: string;
        } | null;
    }
}

export interface IPricingRequestItemDetails {
    pricingRequestId?: number;
    id: number;
    itemcode: string;
    itemData: {
        itemname: string | null;
        price: string;
    };
    volume: string;
    approved: boolean | null;
    approvedByUserId: number | null;
    approvedPrice: string | null;
    expectedPrice: string | null;
}

export interface IPricingRequestDetails {
    id: number;
    cardcode: string | null;
    item: IPricingRequestItemDetails[];
    groupItems: IGroupPriceItem[];
    providerGroup: { id: number; name: string } | null;
    note: string | null;
    complete: boolean;
    createdAt: string;
    updatedAt: string;
    createdByUserId: number;
    createdByUser: {
        id: number;
        name: string;
        username: string;
        email: string;
    };
    providerId: number;
    provider: {
        id: number;
        providerId: string;
        dba: string;
        legalBusName: string;
    };
    approvedPricesModified: boolean;
    groupPricesModified: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/interfaces/pricing.ts